import { render, staticRenderFns } from "./Section8ExposureControl.vue?vue&type=template&id=6d61152d&scoped=true"
import script from "./Section8ExposureControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./Section8ExposureControl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d61152d",
  null
  
)

export default component.exports